var map = {
	"./ExperimentPlate_Disabled.png": 80804,
	"./ExperimentPlate_Dispensed.png": 55157,
	"./ExperimentPlate_Expired.png": 40557,
	"./ExperimentPlate_Expired_Imaged.png": 73179,
	"./ExperimentPlate_Imaged.png": 74021,
	"./ExperimentPlate_Imaged_NotViewed.png": 79059,
	"./Experiment_Designed.png": 75149,
	"./Experiment_Dispensed.png": 27689,
	"./Experiment_Expired.png": 42017,
	"./Experiment_Expired_Hits_16.png": 35896,
	"./Experiment_Imaged.png": 94217,
	"./Experiment_ImagedNotViewed_Hits_16.png": 78487,
	"./Experiment_ImagedViewed_Hits_16.png": 88920,
	"./Experiment_Imaged_NotViewed.png": 57423,
	"./Folder_Hits_16.png": 36995,
	"./Folder_opened.png": 21308,
	"./Folder_opened_Hits_16.png": 26805,
	"./Images_opened.png": 41910,
	"./Integerated_Active.png": 44009,
	"./Integerated_Device.png": 36649,
	"./Integerated_Idel.png": 67,
	"./Integerated_Marco.png": 7873,
	"./Integerated_Offline.png": 37698,
	"./Integerated_PrintBarcode.png": 20416,
	"./Integrated_Device_NewUI.png": 81445,
	"./Integrated_Marco_NewUI.png": 76123,
	"./Integrated_PrintBarcode_NewUI.png": 33704,
	"./Open_Tab_Gray.png": 96306,
	"./Plate_Expired_Hits_16.png": 71203,
	"./Plate_ImagedNotViewed_Hits_16.png": 86376,
	"./Plate_ImagedViewed_Hits_16.png": 66437,
	"./Project_Context.png": 6931,
	"./Project_Hits_16.png": 89582,
	"./Project_opened.png": 45415,
	"./Project_opened_Hits_16.png": 4742,
	"./Projects_opened.png": 43358,
	"./RockMaker_News.png": 54807,
	"./Screen_Dispensed.png": 69008,
	"./Screens_opened.png": 61667,
	"./favorite_Folder.png": 48615,
	"./favorite_FolderHits.png": 23249,
	"./favorite_FolderXtals.png": 9613,
	"./favorite_Project.png": 99996,
	"./favorite_ProjectHits.png": 91954,
	"./favorite_ProjectXtals.png": 21372,
	"./recent_CrystalHarvested.png": 81490,
	"./recent_Designed.png": 40589,
	"./recent_Dispensed.png": 35113,
	"./recent_Expired.png": 5217,
	"./recent_Folder.png": 63344,
	"./recent_Hits.png": 95158,
	"./recent_Imaged.png": 86633,
	"./recent_NewDesigned.png": 33017,
	"./recent_Project.png": 80813
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79134;